import React from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { DarkModeProvider, ErrorBoundary } from '@repo/ui'
import '@repo/ui/styles.css'
import i18n from './i18n'
import ViewportCheckProvider from './providers/ViewportCheckProvider'
import HinweisProvider from './providers/HinweisProvider'
import PwaProvider from './providers/PwaProvider'
import BefehlsnachrichtenProvider from './features/befehlsnachrichten/providers/BefehlsnachrichtenProvider'
import { ConfigProvider } from './features/config/providers/ConfigProvider'
import BetriebsstelleSearchProvider from './providers/BetriebsstelleSearchProvider'
import { Router } from './routes'
import ScrollProgressColorProvider from './providers/ScrollProgressColorProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      retry: 0,
      refetchIntervalInBackground: false
    },
    mutations: {
      networkMode: 'always'
    }
  }
})

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <PwaProvider>
        <DarkModeProvider>
          <QueryClientProvider client={queryClient}>
            <ConfigProvider>
              <ViewportCheckProvider>
                <HinweisProvider>
                  <BetriebsstelleSearchProvider>
                    <ScrollProgressColorProvider>
                      <BefehlsnachrichtenProvider>
                        <ErrorBoundary>
                          <RouterProvider router={Router} />
                        </ErrorBoundary>
                      </BefehlsnachrichtenProvider>
                    </ScrollProgressColorProvider>
                  </BetriebsstelleSearchProvider>
                </HinweisProvider>
              </ViewportCheckProvider>
            </ConfigProvider>
          </QueryClientProvider>
        </DarkModeProvider>
      </PwaProvider>
    </I18nextProvider>
  </React.StrictMode>
)
